import React, { useState } from 'react';

// Utils
import { getHomestoreHref } from 'util/getHomestoreHref';
import featureFlags from 'util/featureFlags';

// Components
import { ChevronRightIcon } from '@zola/zola-ui/src/components/SvgIconsV3/ChevronRight';
import { ChevronLeftIcon } from '@zola/zola-ui/src/components/SvgIconsV3/ChevronLeft';
import { Banner } from './Banner/Banner';

import { mockBanners } from './mockData';

// Styles
import {
  ArrowButton,
  BannerWrapper,
  MultiAnnouncementBannerWrapper,
  PreauthLinksWrapper,
  StyledArrowWrapper,
  StyledLink,
  StyledText,
} from './MultiAnnouncementBanner.styles';

export type MultiAnnouncementBannerProps = {
  hideContentOnScroll?: boolean;
  showPreauthLinks?: boolean;
  leftAlignBanners?: boolean;
};

const MultiAnnouncementBanner = ({
  hideContentOnScroll,
  showPreauthLinks = false,
  leftAlignBanners = false,
}: MultiAnnouncementBannerProps): JSX.Element => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const { color, backgroundColor } = mockBanners[currentBannerIndex];

  const setNextBanner = () => {
    // we've reached the end of the array, start from the beginning
    if (currentBannerIndex === mockBanners.length - 1) {
      setCurrentBannerIndex(0);
    } else {
      setCurrentBannerIndex(currentBannerIndex + 1);
    }
  };

  const setPreviousBanner = () => {
    // we've reached the beginning of the array, start from the end
    if (currentBannerIndex === 0) {
      setCurrentBannerIndex(mockBanners.length - 1);
    } else {
      setCurrentBannerIndex(currentBannerIndex - 1);
    }
  };

  const NextButton = ({ onlyShowOnHover }: { onlyShowOnHover?: boolean }) => {
    return (
      <ArrowButton
        onlyShowOnHover={onlyShowOnHover}
        color={color}
        variant="transparent"
        onClick={setNextBanner}
      >
        <ChevronRightIcon width={20} height={20} />
      </ArrowButton>
    );
  };
  const PreviousButton = ({ onlyShowOnHover }: { onlyShowOnHover?: boolean }) => {
    return (
      <ArrowButton
        onlyShowOnHover={onlyShowOnHover}
        color={color}
        variant="transparent"
        onClick={setPreviousBanner}
      >
        <ChevronLeftIcon width={20} height={20} />
      </ArrowButton>
    );
  };

  return (
    <MultiAnnouncementBannerWrapper
      leftAlignBanners={leftAlignBanners}
      hideContentOnScroll={hideContentOnScroll}
      backgroundColor={backgroundColor}
    >
      <BannerWrapper fullWidth={!leftAlignBanners}>
        {leftAlignBanners && (
          <StyledArrowWrapper>
            <PreviousButton />
            <NextButton />
          </StyledArrowWrapper>
        )}
        {!leftAlignBanners && <PreviousButton onlyShowOnHover />}
        <Banner isLeftAligned={leftAlignBanners} banner={mockBanners[currentBannerIndex]} />
        {!leftAlignBanners && <NextButton onlyShowOnHover />}
      </BannerWrapper>

      {showPreauthLinks && (
        <PreauthLinksWrapper color={color}>
          <StyledText color={color}>
            Shop{' '}
            <StyledLink
              variant="tertiary"
              inline
              noTextTransform
              textcolor={color}
              target="_blank"
              href={getHomestoreHref(featureFlags.getEnvironment())}
            >
              Zola Home
            </StyledLink>
          </StyledText>
          <StyledText color={color}>
            Become a{' '}
            <StyledLink
              variant="tertiary"
              noTextTransform
              inline
              textcolor={color}
              target="_blank"
              href="https://welcome.zola.com/for-vendors/"
            >
              Zola vendor
            </StyledLink>
          </StyledText>
        </PreauthLinksWrapper>
      )}
    </MultiAnnouncementBannerWrapper>
  );
};

export default MultiAnnouncementBanner;
